import { API } from "@/main";

const state = {};
const getters = {};
const mutations = {};
const actions = {
  getChangeLogByObjectUUID({ commit }, { objectUUID, layer }) {
    return new Promise((resolve, reject) => {
      API.changeLog.getByObjectUUID(
        objectUUID,
        layer,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};
export default { state, getters, mutations, actions };



// WEBPACK FOOTER //
// ./src/store/modules/changeLog.js